import { Link } from "react-router-dom";
import { Phone, MessageCircle, CalendarCheck } from "lucide-react";
import { PHONE_TEL, WA_LINK } from "../../lib/site";
import { useLang } from "../../lib/i18n";

export const MobileBar = () => {
    const { t } = useLang();
    return (
    <nav
        data-testid="mobile-action-bar"
        className="fixed inset-x-0 bottom-0 z-50 grid grid-cols-3 border-t border-white/10 bg-night-950/92 backdrop-blur-xl md:hidden"
        style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
    >
        <a
            href={PHONE_TEL}
            data-testid="mobile-bar-call"
            className="flex flex-col items-center gap-1 py-3 text-amber-400 transition-colors active:bg-white/5"
        >
            <Phone size={20} />
            <span className="text-[11px] font-semibold">{t.mobile.call}</span>
        </a>
        <a
            href={WA_LINK}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="mobile-bar-whatsapp"
            className="flex flex-col items-center gap-1 border-x border-white/10 py-3 text-white transition-colors active:bg-white/5"
        >
            <MessageCircle size={20} />
            <span className="text-[11px] font-semibold">{t.mobile.whatsapp}</span>
        </a>
        <Link
            to="/boeken"
            data-testid="mobile-bar-book"
            className="flex flex-col items-center gap-1 py-3 text-white transition-colors active:bg-white/5"
        >
            <CalendarCheck size={20} />
            <span className="text-[11px] font-semibold">{t.mobile.book}</span>
        </Link>
    </nav>
    );
};
